import React from "react";

const Social = () => {
  return (
    <div className="home_social">
      <a
        href="https://www.linkedin.com/in/zhi-hao-lo"
        className="home_social-icon"
        target="_blank">
        <i class="uil uil-linkedin"></i>
      </a>

      <a
        href="https://github.com/LordZhiHao"
        className="home_social-icon"
        target="_blank">
        <i class="uil uil-github"></i>
      </a>

      <a
        href="https://medium.com/@lozhihao"
        className="home_social-icon"
        target="_blank">
        <i class="uil uil-medium-m"></i>
      </a>

      <a
        href="https://linktr.ee/lozhihao"
        className="home_social-icon"
        target="_blank">
        <i class="uil uil-trees"></i>
      </a>
    </div>
  );
};

export default Social;
